import { render, staticRenderFns } from "./MinutaTCPRATextComponent.vue?vue&type=template&id=2153adc2&scoped=true&lang=pug"
import script from "./MinutaTCPRATextComponent.vue?vue&type=script&lang=js"
export * from "./MinutaTCPRATextComponent.vue?vue&type=script&lang=js"
import style0 from "./MinutaTCPRATextComponent.vue?vue&type=style&index=0&id=2153adc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2153adc2",
  null
  
)

export default component.exports